import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { SimpleIndexedDBService } from '../services/simple-indexeddb.service';
import { environment } from '../../environments/environment';
import { UserProfileStorageService } from '../services/user-profile-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SystemReconService {

  constructor(public httpClient: HttpClient, private indexedDB: SimpleIndexedDBService, public toastController: ToastController,
    private userProfileStorage: UserProfileStorageService) { }

  getLastNSystemReconDate(n: number) {
    console.log('getStudentsByAgencyByMasterCalendar(schoolId)'); // todo: comment out logging as needed for prod
    return this.loadLastNSystemReconDate(n);
  }
  
  private loadLastNSystemReconDate(n: number) {
    return this.httpClient.get(environment.reportsUrl + 'topNattendanceReconDates/' + n);
  }

  updateSystemReconDate(reconDate) {
    console.log('updateSystemReconDate() with url: ', environment.reportsUrl + 'UpdateAttendanceReconciliation/' + reconDate);
    return this.httpClient.post( environment.reportsUrl + 'UpdateAttendanceReconciliation/' + reconDate, {}).subscribe(
      result => {
        this.showSuccessToast('Updated System Reconciliation Date');
      },
      error => {
        this.showError(error, null);
      },
    );
  }

  async showSuccessToast(message) {
    if (message === null) {
      message = 'Success!';
    }
    const toast = await this.toastController.create({
      color: 'success',
      duration: 2500,
      message: message,
      showCloseButton: true,
      position: 'top'
    });
    await toast.present();
  }
  async showError(error, message) {
    if (message === null) {
      message = 'Error!';
    }
    console.log(error);
    const toast = await this.toastController.create({
      color: 'danger',
      duration: 2500,
      message: message,
      showCloseButton: true,
      position: 'top'
    });
    await toast.present();
  }


}
